import { createStore } from 'redux';
import { SET_HOME, SET_CURRENTSCENE, SET_TRANSITIONING, SET_HOMENAVIN, SET_ANIMRIGHT, SET_INFOCARDIN, SET_LOCALE, SET_BREAKPOINT} from './actionTypes';

const initialState = {
  currentScene: null,
  home: true,
  transitioning: true,
  homeNavIn: false,
  animRight: true,
  infocardIn: false,
  locale:'en',
  breakpoint: null
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_HOME:
      return { ...state, home: payload };
    case SET_CURRENTSCENE:
      return { ...state, currentScene: payload };
    case SET_TRANSITIONING:
      return { ...state, transitioning: payload };
    case SET_HOMENAVIN:
      return { ...state, homeNavIn: payload };
    case SET_ANIMRIGHT:
      return { ...state, animRight: payload };
    case SET_INFOCARDIN:
      return { ...state, infocardIn: payload };
    case SET_LOCALE:
      return { ...state, locale: payload };   
    case SET_BREAKPOINT:
      return { ...state, breakpoint: payload };               
    default:
      return state;
  }
};

const store = createStore(reducer);

export default store;
